import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Login',
    component: () => import('../components/Login.vue')
  },
  {
    // path: '',
    path: '/',
    name: 'navbar',
    component: () => import('../views/Navbar.vue'),
    children: [
      {
        path: '/dashboard',
        name: 'Dashboard',
        component: () => import('../components/Dashboard.vue')
      },
      {
        path: '/ehpiframe',
        name: 'ehpiframe',
        component: () => import('../views/Ehpiframe.vue')
      },
      {
        path: '/appeal',
        name: 'Appeal',
        component: () => import('../components/Appeal.vue')
      },
      {
        path: '/overview',
        name: 'Overview',
        component: () => import('@/views/Dashboards/Moph.vue')
      },
      {
        path: '/vaccine',
        name: 'Vaccine',
        component: () => import('@/views/Dashboards/Vaccine.vue')
      },
    ]
  },
  {
    path: '/portal',
    name: 'LoginNhso',
    component: () => import('../components/appeal/Login_nhso.vue')
  },
  {
    path: '/',
    name: 'navbarnhso',
    component: () => import('../views/NavbarNhso.vue'),
    children: [
      {
        path: '/portal/appeal',
        name: 'Portal',
        component: () => import('../components/Appealnhso.vue')
      },
    ]
  },
  { path: '*', redirect: '/' }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
